import React from 'react';
import { Link } from 'react-router-dom';
import SEOMeta from '../components/SEOMeta';

const BlogIndex: React.FC = () => {
  const blogPosts = [
    {
      slug: 'what-is-cyber-security',
      title: 'What is Cyber Security? A Complete Beginner\'s Guide',
      description: 'Complete guide to cybersecurity basics, definitions, and importance.',
    },
    {
      slug: 'history-of-cybercrime',
      title: 'History of Cybercrime: From 1820 to Today | Complete Timeline',
      description: 'Complete timeline of cybercrime history from early 1820s to modern attacks.',
    },
    {
      slug: 'top-10-cyber-attacks',
      title: 'Top 10 Cyber Attacks That Changed History | Major Breaches 2025',
      description: 'Complete list of top 10 cyber attacks that changed history.',
    },
    {
      slug: 'common-cyber-attacks',
      title: 'Most Common Cyber Attacks: Types, Prevention & Protection 2025',
      description: 'Complete guide to the most common cyber attacks, their types, prevention methods, and protection strategies.',
  
    },
    {
      slug: 'cybersecurity-best-practices',
      title: 'Cybersecurity Best Practices: Essential Security Measures 2025',
      description: 'Complete guide to cybersecurity best practices and essential security measures for organizations and individuals.',
  
    },
    {
      slug: 'evolution-of-cybersecurity',
      title: 'Evolution of Cybersecurity: From Firewalls to AI Defense 2025',
      description: 'Comprehensive overview of cybersecurity evolution from early firewalls to modern AI-powered defense systems.',

    },
    {
      slug: 'what-is-firewall',
      title: 'What is a Firewall? Complete Guide to Network Security 2025',
      description: 'Complete guide to firewalls, network security, and how firewalls protect your systems.',
  
    },
    {
      slug: 'what-is-vpn',
      title: 'What is VPN? Complete Guide to Virtual Private Networks 2026',
      description: 'Complete guide to VPNs, virtual private networks, and how they protect your privacy.',
    },
    {
      slug: 'vpn-security-guide',
      title: 'Complete VPN Security Guide: Protecting Your Online Privacy 2026',
      description: 'Comprehensive guide to VPN security, privacy protection, and best practices for staying safe online.',
    },
    {
      slug: 'vpn-privacy-protection',
      title: 'VPN Privacy Protection: Safeguarding Your Digital Footprint 2026',
      description: 'Complete guide to VPN privacy protection, digital footprint management, and techniques for maintaining online anonymity.',
    },
    {
      slug: 'vpn-safety-and-security',
      title: 'VPN Safety and Security: Protecting Yourself Online 2026',
      description: 'Complete guide to VPN safety and security, how to choose secure VPN services, and best practices for staying safe online.',
    },
    {
      slug: 'ai-powered-vpns',
      title: 'AI-Powered VPNs: The Future of Cybersecurity 2026',
      description: 'Complete guide to AI-powered VPNs, intelligent threat detection, and how artificial intelligence is revolutionizing VPN security.',
    },
    {
      slug: 'zero-trust-vpns',
      title: 'Zero Trust VPNs: Secure Access in 2026',
      description: 'Complete guide to Zero Trust VPNs, secure access service edge (SASE), and how zero trust architecture is transforming VPN security.',
    },
    {
      slug: 'cyber-attacks-2025',
      title: 'Cyber Attacks in 2025: Trends and Predictions',
      description: 'Analysis of cyber attack trends and predictions for 2025.',
    },
    {
      slug: 'most-popular-cyber-attacks',
      title: 'Most Popular Cyber Attacks in History',
      description: 'Explore the most popular cyber attacks in history that defined cybersecurity.',
    },
    {
      slug: 'worst-cyber-attacks',
      title: 'Worst Cyber Attacks in History: Devastating Incidents That Changed Digital Security Forever',
      description: 'Explore the worst cyber attacks in history that caused massive damage, financial losses, and infrastructure disruption.',
    },
    {
      slug: 'ai-driven-cyber-attacks',
      title: 'AI-Driven Cyber Attacks: Understanding the New Threat Landscape',
      description: 'Comprehensive guide to AI-driven cyber attacks, their impact, and defense strategies.',
    },
    {
      slug: 'zero-trust-architecture',
      title: 'Zero Trust Architecture: From Concept to Continuous Verification in 2026',
      description: 'Complete guide to Zero Trust Architecture, implementation strategies, and how it protects against modern cyber threats.',
    },
    {
      slug: 'ransomware-as-a-service',
      title: 'Ransomware-as-a-Service (RaaS): The Commoditization of Cybercrime in 2026',
      description: 'Complete guide to Ransomware-as-a-Service, how it operates, and defense strategies.',
    },
    {
      slug: 'deepfakes-synthetic-identity',
      title: 'Deepfakes and Synthetic Identity: AI-Enabled Social Engineering',
      description: 'Complete guide to deepfakes, synthetic identity fraud, and AI-enabled social engineering.',
    },
    {
      slug: 'cloud-security-solutions',
      title: 'Cloud Security Solutions: Protecting Cloud and Hybrid Environments ',
      description: 'Complete guide to cloud security solutions, threats, and best practices.',
    },
    {
      slug: 'post-quantum-cryptography',
      title: 'Post-Quantum Cryptography: Preparing for Quantum-Safe Encryption',
      description: 'Complete guide to post-quantum cryptography, quantum computing threats, and quantum-safe encryption.',
    },
    {
      slug: 'first-cyber-crime-1820',
      title: 'First Cyber Crime in 1820: The Hidden History of Digital Crime Origins',
      description: 'Discover the surprising history of the first cyber crime in 1820 and the origins of digital crime.',
    },
    {
      slug: 'top-biggest-cyber-attacks',
      title: 'Top Biggest Cyber Attacks in History',
      description: 'Complete guide to the top biggest cyber attacks in history, most devastating incidents, and major data breaches that changed cybersecurity forever.',
    },
    // {
    //   slug: 'recently-hacked-companies',
    //   title: 'Companies That Have Been Hacked Recently: Latest Data Breaches and Security Incidents',
    //   description: 'Complete guide to companies that have been hacked recently, latest data breaches, and cyber security incidents. Learn about recent company breaches, security incidents, and protection strategies.',
    // },
    // {
    //   slug: 'the-evolution-of-malware',
    //   title: 'The Evolution of Malware: From Simple Viruses to Advanced Persistent Threats',
    //   description: 'Comprehensive guide to malware evolution, from early computer viruses to modern advanced persistent threats. Learn about malware development, techniques, and how defenses have evolved.',
    // },
    // {
    //   slug: 'the-biggest-hack-in-us-history',
    //   title: 'The Biggest Hack in US History: Unprecedented Cybersecurity Breaches and Their Impact',
    //   description: 'Complete analysis of the biggest hack in US history, unprecedented cybersecurity breaches, and their national impact. Learn about major US cyber attacks and their consequences.',
    // },
    // {
    //   slug: 'the-most-destructive-hack',
    //   title: 'The Most Destructive Hack Ever: Cyber Attacks That Caused Maximum Damage',
    //   description: 'Complete analysis of the most destructive hack ever, cyber attacks that caused maximum damage, and incidents with catastrophic consequences. Learn about devastating cyber attacks and their aftermath.',
    // },
    {
      slug: 'threat-intelligence-index-2025',
      title: '2025 Threat Intelligence Index: Predicting the Future of Cyber Warfare',
      description: 'Complete guide to the 2025 threat intelligence index, future of cyber warfare, and emerging cyber threats. Learn about threat predictions, attack trends, and cybersecurity forecasts for 2025.',
    },
    {
      slug: 'defeat-the-quantum-menace',
      title: 'Defeat the Quantum Menace: Protecting Data from Quantum Computers',
      description: 'Complete guide to quantum computing threats and how to protect data from quantum computers. Learn about post-quantum cryptography, crypto-agility, and quantum-resistant security measures for 2026.',
    },
    // {
    //   slug: 'hacking-history',
    //   title: 'Hacking History: From Phone Phreaking to Modern Cyber Warfare',
    //   description: 'Comprehensive guide to hacking history, from early phone phreaking to modern cyber warfare. Learn about legendary hackers, hacking culture, and how hacking has evolved over decades.',
    // },
    {
      slug: 'cybersecurity-trends-in-2026',
      title: 'Cybersecurity Trends in 2026: What to Expect in the Next Year',
      description: 'Complete analysis of cybersecurity trends in 2026, what to expect in the next year, and emerging security technologies. Learn about future security challenges and solutions.',
    },
    // {
    //   slug: 'threats-vulnerabilities-and-exploits',
    //   title: 'Threats, Vulnerabilities, and Exploits: The Hacker\'s Arsenal in 2026',
    //   description: 'Complete guide to threats, vulnerabilities, and exploits, the hacker\'s arsenal in 2026. Learn about CVEs, zero-days, exploit techniques, and how to defend against them.',
    // },
    {
      slug: 'wannacry',
      title: 'WannaCry: The Global Ransomware Pandemic',
      description: 'Complete analysis of WannaCry, the global ransomware pandemic that changed cybersecurity forever. Learn about the attack, its impact, and lessons learned from this historic cyber incident.',
    },
    {
      slug: 'zero-click-attacks',
      title: 'Zero-Click Attacks: The Invisible Threat in Modern Cybersecurity',
      description: 'Complete guide to zero-click attacks, the invisible threat in modern cybersecurity. Learn about zero-click exploits, spyware, and how to defend against attacks that require no user interaction.',
    },
    {
      slug: 'every-type-of-cyber-attack',
      title: 'Every Type of Cyber Attack: Complete Guide to Threat Categories',
      description: 'Complete guide to every type of cyber attack, threat categories, and attack vectors. Learn about malware, phishing, DDoS, APTs, and all major cyber attack classifications in 2026.',
    },
    {
      slug: 'cyber-attack-categories',
      title: 'Cyber Attack Categories: Complete Guide to Threat Classifications',
      description: 'Complete guide to cyber attack categories and classifications. Explore network-based, web application, social engineering, malware, authentication, physical, cryptographic, wireless/IoT, and advanced attack types.',
    },
    {
      slug: 'youtube-longest-video',
      title: 'Longest 141-Year Video on Youtube',
      description: 'Complete technical analysis of the viral YouTube 141-year duration video incident from January 2026. Metadata manipulation, platform glitch exploitation, and security implications explained.',
    }
    ,
    {
      slug: 'geo-news-hack-incident-2026',
      title: 'Geo News Hack Today (March 1, 2026): Satellite Transmission Hijacked With Anti-Military Message',
      description: 'Breaking: Geo News satellite transmission hacked today with anti-military messages. Live updates on Pakistan\'s major news channel cyber attack incident and official response.',
    },
    {
  slug: 'vercel-data-breach-2026',  
  title: 'Vercel Data Breach 2026: Hackers Access Internal Systems via Compromised AI Tool',
  description: 'Breaking: Vercel confirms major data breach on April 19, 2026. Environment variables exposed, ShinyHunters claims $2M ransom. Latest updates and security recommendations for developers.',
},
{
  slug: 'github-data-breach-2026',
  title: 'GitHub Data Breach 2026: 3,800 Internal Repos Stolen via VS Code Extension',
  description: 'Breaking: GitHub confirms major data breach on May 19, 2026. Attackers used poisoned VS Code extension to steal ~3,800 internal repos. TeamPCP demands $50K. Full incident analysis and security recommendations.',
},
  ];

  // Blog structured data for SEO
  const blogStructuredData = {
    "@context": "https://schema.org",
    "@type": "Blog",
    "name": "CyberAnnals Blog",
    "description": "Latest cybersecurity insights, historical analysis, and educational content covering the evolution of cyber threats and defense strategies.",
    "url": "https://cyberannals.com/blog",
    "blogPosts": blogPosts.map(post => ({
      "@type": "BlogPosting",
      "headline": post.title,
      "description": post.description,
      "url": `https://cyberannals.com/blog/${post.slug}`
    }))
  };

  return (
    <div className="max-w-6xl mx-auto px-4 py-8 sm:py-12">
      <SEOMeta
        title="Cyber Security Blog | Latest Cyber Attack News & Analysis"
        description="Latest cybersecurity blog posts, news, and analysis. Learn about cyber attacks, security trends, and historical events in cybersecurity."
        keywords="cybersecurity blog, cyber attacks blog, security news, cyber security articles, cybersecurity education, cybercrime analysis"
        canonical="https://cyberannals.com/blog"
        ogType="website"
        structuredData={blogStructuredData}
      />

      <header className="mb-12 text-center">
        <h1 className="text-3xl sm:text-4xl font-black text-white mb-4">
          Cyber Security Blog
        </h1>
        <p className="text-lg text-slate-300 max-w-2xl mx-auto">
          Latest cybersecurity insights, historical analysis, and educational content covering the evolution of cyber threats and defense strategies.
        </p>
      </header>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
        {blogPosts.map((post, index) => (
          <article
            key={index}
            className="bg-slate-800/50 backdrop-blur-sm rounded-xl shadow-sm hover:shadow-lg transition-all duration-300 overflow-hidden border border-slate-700/50 hover:border-blue-500/30 group"
          >
            <div className="p-6">

              <h2 className="text-xl font-bold text-white mb-3 line-clamp-2 group-hover:text-blue-300 transition-colors">
                {post.title}
              </h2>

              <p className="text-slate-300 mb-4 line-clamp-3">
                {post.description}
              </p>

              <Link
                to={`/blog/${post.slug}`}
                className="inline-flex items-center text-blue-400 hover:text-blue-300 font-medium group-hover:underline"
              >
                Read Article
                <svg className="w-4 h-4 ml-1 transition-transform group-hover:translate-x-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                </svg>
              </Link>
            </div>
          </article>
        ))}
      </div>

      <div className="mt-12 text-center">
        <p className="text-slate-300 mb-6">
          Explore more about cybersecurity history and current events
        </p>
        <div className="flex flex-wrap justify-center gap-4">
          <Link
            to="/decades"
            className="px-6 py-3 bg-blue-600 hover:bg-blue-700 text-white rounded-lg font-medium transition-colors"
          >
            Browse Cyber History
          </Link>
          <Link
            to="/toolkit"
            className="px-6 py-3 border border-slate-600 hover:border-blue-500 hover:bg-slate-800 text-slate-300 rounded-lg font-medium transition-colors"
          >
            Security Tools
          </Link>
        </div>
      </div>
    </div>
  );
};

export default BlogIndex;
